import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Card, CardContent } from '@/components/ui/card';
import { FileText } from 'lucide-react';

const TermsOfUse: React.FC = () => {
  return (
    <div className="min-h-screen bg-sauna-beige py-12 px-4">
      <Helmet>
        <title>Terms of Use | SaunaDip</title>
        <meta name="description" content="SaunaDip Terms of Use" />
      </Helmet>
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-sauna-navy flex items-center justify-center gap-2">
            <FileText className="h-8 w-8 text-sauna-orange" />
            Terms of Use
          </h1>
          <div className="h-1 w-32 divider-gradient rounded-full mx-auto mt-4"></div>
        </div>
        <Card className="border-none shadow-lg">
          <CardContent className="p-8">
            <div className="prose max-w-none">
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6">1. Acceptance of Terms</h2>
              <p className="text-sauna-navy/90">By accessing and using the SaunaDip website and services, you agree to be bound by these Terms of Use...</p>
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6 mt-12">2. Changes to Terms</h2>
              <p className="text-sauna-navy/90">We reserve the right to modify or replace these Terms at any time...</p>
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6 mt-12">3. User Accounts</h2>
              <p className="text-sauna-navy/90">You are responsible for maintaining the confidentiality of your account and password...</p>
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6 mt-12">4. Prohibited Conduct</h2>
              <p className="text-sauna-navy/90">You agree not to use the website for any unlawful purpose...</p>
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6 mt-12">5. Intellectual Property</h2>
              <p className="text-sauna-navy/90">All content on the website is the property of SaunaDip...</p>
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6 mt-12">6. Disclaimer of Warranties</h2>
              <p className="text-sauna-navy/90">The website and services are provided "as is" without warranty of any kind...</p>
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6 mt-12">7. Limitation of Liability</h2>
              <p className="text-sauna-navy/90">SaunaDip shall not be liable for any indirect, incidental, special, consequential or punitive damages...</p>
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6 mt-12">8. Governing Law</h2>
              <p className="text-sauna-navy/90">These Terms shall be governed and construed in accordance with the laws of Ireland...</p>
              <h2 className="text-2xl font-bold text-sauna-navy flex items-center mb-6 mt-12">9. Contact Us</h2>
              <p className="text-sauna-navy/90">If you have any questions about these Terms, please contact us...</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfUse; 